import { useDispatch, useSelector } from 'react-redux'
import Input from '../../../../../UI/Input/Input'
import { setLocal } from '../../../../../../redux/action/local'
import props from '../../../../../../redux/props'

const PortfolioInvestmentVolume = () => {
  const translations = useSelector((state) => state.translations)
  const purchaseProfile = useSelector((state) => state.PURCHASE_PROFILE)
  const dispatch = useDispatch()

  const update = (key) => (value) => {
    // dispatch(setNewPurchaseProfile({ ...purchaseProfile, portfolioInvestmentVolume: { ...purchaseProfile.portfolioInvestmentVolume, [key]: value } }))
    dispatch(setLocal(props.PURCHASE_PROFILE, { ...purchaseProfile, portfolioInvestmentVolume: { ...purchaseProfile.portfolioInvestmentVolume, [key]: value } }))
  }

  return (
    <div className="wrapper">
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.assets-class.portfolio-investment-volume.single']}</div>
        <div className="values">
          <div className="subgroup">
            <div className="element">
              <Input
                type="customNumber"
                symbol={translations['currency.string']}
                value={purchaseProfile.portfolioInvestmentVolume.singleFrom}
                onChange={update('singleFrom')}
                placeholder={translations['my-objects.pipeline.assets-class.portfolio-investment-volume.from']}
              />
            </div>
            <div className="element">
              <Input
                type="customNumber"
                symbol={translations['currency.string']}
                value={purchaseProfile.portfolioInvestmentVolume.singleTo}
                onChange={update('singleTo')}
                placeholder={translations['my-objects.pipeline.assets-class.portfolio-investment-volume.to']}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.assets-class.portfolio-investment-volume.total']}</div>
        <div className="values">
          <div className="subgroup">
            <div className="element">
              <Input
                type="customNumber"
                symbol={translations['currency.string']}
                value={purchaseProfile.portfolioInvestmentVolume.totalFrom}
                onChange={update('totalFrom')}
                placeholder={translations['my-objects.pipeline.assets-class.portfolio-investment-volume.from']}
              />
            </div>
            <div className="element">
              <Input
                type="customNumber"
                symbol={translations['currency.string']}
                value={purchaseProfile.portfolioInvestmentVolume.totalTo}
                onChange={update('totalTo')}
                placeholder={translations['my-objects.pipeline.assets-class.portfolio-investment-volume.to']}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.assets-class.portfolio-investment-volume.min-invest-single']}</div>
        <div className="values">
          <div className="subgroup">
            <div className="element">
              <Input
                type="customNumber"
                symbol={translations['currency.string']}
                value={purchaseProfile.portfolioInvestmentVolume.minInvestSingle}
                onChange={update('minInvestSingle')}
                placeholder={translations['my-objects.pipeline.assets-class.portfolio-investment-volume.min-invest-single']}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PortfolioInvestmentVolume
